
import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Paginator = props => {

    const {
        changePage,
        first,
        isBlocked = false,
        isEmpty,
        last,
        pageNumber,
        totalPages,
        floatLeft,
        floatRight
    } = props;

    if(isEmpty) {
        return null;
    }

    const getItems = () => {

        const checkInputValue = (value, target, callback) => {
            if(!value.match(/[0-9]/) || (value < 0 || value > totalPages)) {
                target.value = '';
            } else {
                callback();
            }
        };

        const handleChangePage = e => {

            if(isBlocked) {
                return null;
            }

            const { new_page_number } = e.currentTarget.dataset;

            if(new_page_number < 1 || new_page_number > totalPages) {
                return null;
            }
            changePage(+new_page_number - 1);
        };

        const handleInputBlur = e => {
            const {
                value: new_page_number
            } = e.target;

            checkInputValue(
                new_page_number,
                e.target,
                () => handleChangePage(
                    {
                        currentTarget: {
                            dataset: {
                                new_page_number
                            }
                        }
                    }
                )
            );
        };

        const handleKeyUp = e => {
            if(e.key === 'Enter') {
                checkInputValue(
                    e.target.value,
                    e.target,
                    () => handleChangePage(
                        {
                            currentTarget: {
                                dataset: {
                                    new_page_number: e.target.value
                                }
                            }
                        }
                    )
                );
            }
        };

        const getArrowedItem = (isShown, arrowDirection, number) => {

            if(!isShown) {
                return null;
            }

            const className = classNames(
                'paginator-item',
                { 'blocked': isBlocked }
            );

            return (
                <span
                    className = { className }
                    data-new_page_number = { String(number) }
                    key = { arrowDirection }
                    onClick = { handleChangePage }
                >
                    <FontAwesomeIcon icon = { arrowDirection }/>
                </span>
            );
        };

        let pageCounter = 0;

        const getItem = (number, isInput, isActive) => {

            pageCounter++;

            const className = classNames(
                'paginator-item',
                { 'blocked': isBlocked },
                { 'active': isActive },
                { 'with-input': isInput }
            );

            return (
                <span
                    className = { className }
                    data-new_page_number = { String(number) }
                    key = { pageCounter }
                    onClick = { isInput ? () => {} : handleChangePage }
                >
                    {
                        isInput ?
                            <input
                                data-new_page_number = { String(number) }
                                onBlur = { handleInputBlur }
                                onKeyUp = { handleKeyUp }
                                placeholder = '...'
                            /> :
                            number
                    }
                </span>
            );
        };

        const getFirstPage = () => {
            if(first) {
                return null;
            }
            return getItem(1);
        };

        const getPreviousBreadCrumbs = () => {

            if(pageNumber < 3) {
                return null;
            }
            return getItem(null, true);
        };

        const getPreviousPage = currentPage => {
            if(pageNumber < 2) {
                return null;
            }
            return getItem(currentPage - 1);
        };

        const getCurrentPage = currentPage => {
            return getItem(currentPage, null, true);
        };

        const getNextPage = currentPage => {
            if(totalPages - currentPage <= 1) {
                return null;
            }
            return getItem(currentPage + 1);
        };

        const getNextBreadCrumbs = currentPage => {
            if(totalPages - currentPage <= 2) {
                return null;
            }
            return getItem(null, true);
        };

        const getLastPage = currentNumber => {
            if(currentNumber === totalPages) {
                return null;
            }
            return getItem(totalPages);
        };

        return [
            getArrowedItem(!first, 'chevron-left', pageNumber),
            getFirstPage(),
            getPreviousBreadCrumbs(),
            getPreviousPage(pageNumber + 1),
            getCurrentPage(pageNumber + 1),
            getNextPage(pageNumber + 1),
            getNextBreadCrumbs(pageNumber + 1, ),
            getLastPage(pageNumber + 1),
            getArrowedItem(!last, 'chevron-right', pageNumber + 2)
        ];
    };

    const className = classNames(
        'grid-row',
        'margin-top-2em',
        { 'text-left': floatLeft },
        { 'text-right': floatRight }
    );

    return (
        <div className = { className }>
            <div className = 'paginator-items-container'>
                { getItems() }
            </div>
        </div>

    );
};

export default Paginator;